import React from 'react';
import { Controller } from 'react-hook-form';
import { theme } from 'theme';
import { CustomFormTextField } from '../BreakoutRoomForm';
import { Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { SdmImageUploader, SdmSpacer, SdmTypography } from 'components';
import { cdnUrl as CDN_URL } from 'utils/constants';

const SpeakerBox = ({ speaker, idx, control, i18n, handleRemove, errors }) => {
  const renderError = (idx, labelKey) => {
    if (
      errors.speakers?.[idx]?.[labelKey] &&
      errors.speakers?.[idx]?.[labelKey]?.type === 'required'
    ) {
      return (
        <SdmTypography
          style={{ color: `${theme.colors.primary.red}` }}
          variant={'textBold'}
        >
          {i18n[labelKey].error}
        </SdmTypography>
      );
    }
    return null;
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#F3F3F3',
        padding: 16,
        borderRadius: 5,
      }}
    >
      <Grid container>
        <Grid item sm={12} md={4}>
          <Controller
            name={`speakers[${idx}].givenName`}
            control={control}
            defaultValue={speaker.givenName}
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={props.value}
                label={i18n.givenName.label}
                style={{ width: '97%' }}
              />
            )}
          />
          {renderError(idx, 'givenName')}
        </Grid>
        {/* <Grid item sm={null} md={1} /> */}
        <Grid item sm={12} md={4}>
          <Controller
            name={`speakers[${idx}].familyName`}
            control={control}
            defaultValue={speaker.familyName}
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={props.value}
                label={i18n.familyName.label}
                style={{ width: '97%' }}
              />
            )}
          />
          {renderError(idx, 'familyName')}
        </Grid>
        <Grid item sm={12} md={4}>
          <Controller
            name={`speakers[${idx}].jobTitle`}
            control={control}
            defaultValue={speaker.jobTitle}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={props.value}
                label={i18n.jobTitle}
                style={{ width: '97%' }}
              />
            )}
          />
        </Grid>
        <Grid item sm={null} md={1} />
        <SdmSpacer height={10} />
        <Grid item sm={12} md={11}>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              flexDirection: 'row',
            }}
          >
            <SdmTypography variant={'h4Regular'}>
              {i18n.coverImage}
            </SdmTypography>
            <Controller
              name={`speakers[${idx}].coverImage`}
              control={control}
              defaultValue={speaker?.coverImage}
              render={(props) => {
                const url = speaker?.coverImage;

                return (
                  <SdmImageUploader
                    onUploaded={(value) => {
                      props.onChange(value);
                    }}
                    style={{ marginLeft: 30 }}
                    value={
                      url
                        ? typeof url === 'string'
                          ? `${CDN_URL}/${url}`
                          : url.data
                        : null
                    }
                  />
                );
              }}
            />
          </div>
        </Grid>
        <Controller
          name={`speakers[${idx}].oldId`}
          control={control}
          as={<input type="text" hidden />}
          defaultValue={speaker.oldId}
        />
      </Grid>
      <CloseIcon
        onClick={() => handleRemove(idx, speaker?.oldId || '')}
        style={{
          height: 25,
          width: 25,
          color: theme.colors.primary.red,
          cursor: 'pointer',
          borderRadius: '100%',
          border: `1px solid ${theme.colors.primary.red}`,
          marginLeft: 10,
        }}
      />
    </div>
  );
};

export default SpeakerBox;
